import "./SidebarComponent.css";
import IconButton from '@material-ui/core/IconButton';
import Fab from '@material-ui/core/Fab';
import HighlightOff from '@material-ui/icons/HighlightOff';
import Send from '@material-ui/icons/Send';
import { Tooltip } from '@material-ui/core';
import React, { Component } from 'react';
import Linkify from 'react-linkify';
import { withStyles } from '@material-ui/core/styles';

import BulleDroiteSVG from './speak-1.svg';
import BulleGaucheSVG from './speak-2.svg';

import {
  isBrowser,
  isMobile,
  browserName,
  isMobileOnly,
} from "react-device-detect";

const xCloseIcon = require('../../images/x-close.svg');

const StyledTooltip = withStyles({
  popper: {
    zIndex : 9999999999,

  },
  tooltip: {
    backgroundColor : '#2B2B2B',
    fontSize : '12px',
    fontFamily : 'inherit',
    borderRadius : 0,
  },
})(Tooltip);

export default class SidebarComponent extends Component {
  constructor(props) {
      super(props);
      this.state = {
          messageList: [],
          message: '',
          activeSendBtn : false,
      };
      this.chatScroll = React.createRef();

      this.handleChange = this.handleChange.bind(this);
      this.handlePressKey = this.handlePressKey.bind(this);
      this.close = this.close.bind(this);
      this.sendMessage = this.sendMessage.bind(this);

      console.log("sidebar constructor");

  }

  componentDidMount() {
    if (isMobileOnly) {
      var storageMsgs = JSON.parse(sessionStorage.getItem('chatMsgs'));
      if (storageMsgs != null) {
        this.setState({
          messageList: storageMsgs
        });
      }
      this.props.user.getStreamManager().stream.session.on('signal:chat', (event) => {
          const data = JSON.parse(event.data);
          let messageList = this.state.messageList;
          var avatar = "data:image/svg+xml;base64,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";
          /*if (data.avatar != "") {
            avatar = data.avatar;
          }*/
          messageList.push({ timestamp : data.timestamp, avatar : avatar, connectionId: event.from.connectionId, nickname: data.nickname, message: data.message });
          this.setState({ messageList: messageList });
          this.scrollToBottom();
      });
      this.scrollToBottom();
    } else {
      this.props.user.getStreamManager().stream.session.on('signal:chat', (event) => {
          const data = JSON.parse(event.data);
          let messageList = this.state.messageList;
          var avatar = "data:image/svg+xml;base64,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";
          /*if (data.avatar != "") {
            avatar = data.avatar;
          }*/
          messageList.push({ timestamp : data.timestamp, avatar : avatar, connectionId: event.from.connectionId, nickname: data.nickname, message: data.message });
          this.setState({ messageList: messageList });
          this.scrollToBottom();
          this.props.messageReceived();
      });
    }
  }

  componentWillUnmount() {
    /*if (isMobileOnly) {
      sessionStorage.setItem('chatMsgs', JSON.stringify(this.state.messageList));
    }*/
  }

  handleChange(event) {
      if (event.target.value.length > 0) {
        this.setState({
          message: event.target.value,
          activeSendBtn : true,
        });
      } else {
        this.setState({
          message: event.target.value,
          activeSendBtn : false,
        });
      }
  }

  handlePressKey(event) {
      if (event.key === 'Enter') {
          this.sendMessage();
      }
  }

  sendMessage() {
      //console.log(this.state.message);
      if (this.props.user && this.state.message) {
          let message = this.state.message.replace(/ +(?= )/g, '');
          if (message !== '' && message !== ' ') {
              //console.log(this.props.userData.avatarS3Link);
              const data = { timestamp : Date.now(), avatar : this.props.userData.avatarS3Link, message: message, nickname: this.props.user.getNickname(), streamId: this.props.user.getStreamManager().stream.streamId };
              this.props.user.getStreamManager().stream.session.signal({
                  data: JSON.stringify(data),
                  type: 'chat',
              });
          }
      }
      this.setState({ message: '', activeSendBtn : false, });
  }

  scrollToBottom() {
      setTimeout(() => {
          try {
              this.chatScroll.current.scrollTop = this.chatScroll.current.scrollHeight;
          } catch (err) {}
      }, 20);
  }

  close() {
      this.props.close(undefined);
  }

  formatNickname(nickname) {
    var split = nickname.split(" ");
    var prenom = split[0];
    return prenom;
  }

  formatTimestamp(timestamp) {
    var h = new Date(timestamp).getHours();
    var m = new Date(timestamp).getMinutes();

    h = (h<10) ? '0' + h : h;
    m = (m<10) ? '0' + m : m;

    var output = h + ':' + m;
    return output;
  }


  render() {
      return (
        <React.Fragment>
          <div
            className="side-bar"
            style={{
              transform: `translatex(${this.props.xPosition}px)`,
            }}
          >

            <div id="chatContainer">
                <div id="chatComponent">
                    <div id="chatToolbar">
                        <span>Conversation</span>
                        <IconButton id="closeButtonChat" onClick={this.close}>
                            <img
                              className="sideBarClose"
                              src={xCloseIcon}
                            />
                        </IconButton>
                    </div>
                    <div className="message-wrap" ref={this.chatScroll}>
                        {this.state.messageList.map((data, i) => (
                            <div
                                key={i}
                                id="remoteUsers"
                                className={
                                    'message' + (data.connectionId !== this.props.user.getConnectionId() ? ' left' : ' right')
                                }
                            >
                                <img src={data.avatar} width="40" height="40" className="user-img" />
                                <div className="msg-detail">
                                    <div className="msg-content">
                                        {data.connectionId !== this.props.user.getConnectionId() ?
                                          <img src={BulleGaucheSVG} className="triangle" />
                                         :
                                          <img src={BulleDroiteSVG} className="triangle" />
                                        }
                                        <p className="text">
                                          <Linkify componentDecorator={(decoratedHref, decoratedText, key) => ( <a target="blank" href={decoratedHref} key={key}> {decoratedText} </a> )} >
                                            {data.message}
                                          </Linkify>
                                        </p>
                                    </div>
                                </div>
                                <div className="msg-hour">
                                  <p>
                                  {data.connectionId == this.props.user.getConnectionId() ? (
                                    <>Moi</>
                                  ) : (
                                    <>{this.formatNickname(data.nickname)}</>
                                  )}
                                  &nbsp;-&nbsp;
                                  {this.formatTimestamp(data.timestamp)}
                                  </p>
                                </div>
                            </div>
                        ))}
                    </div>

                    <div id="messageInput">
                        <input
                            placeholder="Taper votre message ..."
                            id="chatInput"
                            autoComplete="off"
                            value={this.state.message}
                            onChange={this.handleChange}
                            onKeyPress={this.handlePressKey}
                        />
                        <StyledTooltip title="Envoyer votre message" placement="left-start">
                          <IconButton id="sendButton" className={this.state.activeSendBtn ? 'activeSendBtnChat' : null} onClick={this.sendMessage}>
                              <span className="icon-Send-icon"></span>
                          </IconButton>
                        </StyledTooltip>
                    </div>
                </div>
            </div>

          </div>
        </React.Fragment>
      );
  }
};
